import PropTypes from "prop-types"

import ServiceCard from "shared/components/service_card.js"
import { serviceShape } from "app/lib/shared_prop_types"

const SearchServiceCard = ({ service, path }) => {
  return (
    <li className="service-card-list-item">
      <ServiceCard service={service} path={path} />
    </li>
  )
}

SearchServiceCard.propTypes = {
  location: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  service: serviceShape.isRequired,
  term: PropTypes.string,
}

SearchServiceCard.defaultProps = {
  service: {},
}

export default SearchServiceCard
